import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Adjustment, SlideMenu, State } from "../menu/SlideMenu";
import { AnimationListComponent } from "./AnimationListComponent";
import { AnimationPreviewComponent } from "./AnimationPreviewComponent";
import { UndoRedoSlideMenu } from "../editor/UndoRedoSlideMenu";
import styled from "styled-components";
import { AnimationInspector } from "./AnimationInspector";
import { undoableAnimationEditorSelectAnimationState } from "../../stores/undo/operation/AnimationEditorSelectionOp";
import { animationEditorStore } from "../../stores/AnimationSelectionStore";
import { editorClient } from "../../communication/EditorClient";
const PreviewContainer = styled.div.withConfig({
  displayName: "AnimationEditor__PreviewContainer",
  componentId: "sc-da03nk-0"
})(["position:absolute;left:280px;top:40px;"]);
export const AnimationEditor = observer(() => {
  var _animationEditorStore;

  useEffect(() => {
    if (!animationEditorStore.selectedAnimation) return undefined;
    editorClient.startTrackingAnimation(animationEditorStore.selectedAnimation.animation);
    return () => editorClient.stopTrackingAnimation();
  }, [(_animationEditorStore = animationEditorStore.selectedAnimation) === null || _animationEditorStore === void 0 ? void 0 : _animationEditorStore.animation.id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideMenu, {
    orientation: Adjustment.Left,
    start: 40,
    state: State.Expanded,
    collapsible: false,
    identifier: "animation"
  }, /*#__PURE__*/React.createElement(AnimationListComponent, null)), /*#__PURE__*/React.createElement(UndoRedoSlideMenu, null), /*#__PURE__*/React.createElement(PreviewContainer, null, /*#__PURE__*/React.createElement(AnimationPreviewComponent, {
    store: animationEditorStore,
    showZoomSlider: true,
    editMode: true
  })), animationEditorStore.selectedAnimation && /*#__PURE__*/React.createElement(AnimationInspector, {
    onAnimationStateChange: name => {
      undoableAnimationEditorSelectAnimationState(name, animationEditorStore);
    }
  }));
});